import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.deepPurple,
        secondary: colors.grey.darken3,
        accent: colors.blue.accent2,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange.darken1,
        // custom
        background: colors.blueGrey.lighten5,
        overlay: colors.grey.lighten1
      }
    }
  }
})
